import Vue from 'vue';
import Vuex from 'vuex';
import { asyncRouterMap, constantRouterMap } from '@/router'
import {Message} from 'view-design';
import http from '@/utils/http'
import Layout from '@/view/home/Index'
import router from '@/router'
Vue.use(Vuex);

function generaMenu (routers, data) {
	data.forEach((item) => {
		let menu = {
			path: item.Url,
			component: !item.File ? Layout : () => import(`@/view${item.File}`),
			hidden: true,
			children: [],
			name: item.Name,
			meta: {title: item.Title, icon: item.Icon, id: item.Id}
		}
		routers.push(menu)
		if (item.Childrens) {
			let children = item.Childrens;
			children.forEach((items) => {
				let menuChildren = {
					path: items.Url,
					component: () => import(`@/view${items.File}`),
					hidden: true,
					children: [],
					name: items.Name,
					meta: {title: items.Title, icon: items.Icon, id: items.Id}
				}
				routers.push(menuChildren)
			})
			// generaMenu(menu.children, item.Childrens)

		}
		// routers.push(menu)
	})
}

function hasPermission(roles, route) {
	if (route.meta && route.meta.role) {
		return roles.some(role => route.meta.role.indexOf(role) >= 0)
	} else {
		return true
	}
}

const state = {
	tableHight : '',
	token : window.localStorage.getItem('token'),//登录token
	userinfo : window.localStorage.getItem('userinfo') && window.localStorage.getItem('userinfo') !== 'undefined' ? JSON.parse(window.localStorage.getItem('userinfo')) : '' ,
	nav_id : 1 ,
	open_names : 1 ,
	active_names : 1 ,
	routers: constantRouterMap,
	addRouters: [],
	auth : '',
	parentRouterName : '',
}

const mutations = {
	SET_OPEN_NAMES(state , data){
		state.open_names = data;
		localStorage.setItem('open_names', data);
	},
	SET_ACTIVE_NAMES(state , data){
		state.active_names = data;
		localStorage.setItem('active_names', data);
	},
	//设置路由父名称
	SET_PARENT_ROUTER_NAME(state , data){
		state.parentRouterName = data;
	},
	//设置自适应高度
	SET_TABLE_HEIGHT(state , data){
		state.tableHight = data;
	},
	//设置token
	SET_TOKEN(state , data){
		state.token = data;
		localStorage.setItem('token', data);
	},
	//设置用户信息
	SET_USERINFO(state , data){
		state.userinfo = data;
		localStorage.setItem('userinfo', JSON.stringify(data));
	},
	//设置路由信息
	SET_ROUTERS(state, routers){
		state.addRouters = routers
		state.routers = constantRouterMap.concat(routers)
		//这里将动态组装的路由添加到路由里面
		for(let x of state.routers){
			router.addRoute(x)
		}
	},
	//路由权限
	SET_AUTH(state , data){
		state.auth = data;
		localStorage.setItem('auth', data);
	}
}

const getters = {
	token(state){
		return state.token
	},
	addRouters(){
		return state.addRouters
	}
}

const actions = {
	GetUserInfo ({ commit }, data) {
		return new Promise(resolve => {

		})
	},
	GenerateRoutes ({ commit }, data) {
		return new Promise(resolve => {
			// 获取缓存中的菜单信息
			if (state.auth) {
				let routers = []
				generaMenu(routers,  JSON.parse(state.auth))
				let unfound = { path: '*', redirect: '/404', hidden: true }
				routers.push(unfound)
				commit('SET_ROUTERS', routers)
				resolve()
			} else {
				//没有就请求接口 获取菜单接口
				http.get('/admin/auth/getAuth').then(function (e) {
					if(e.code==0) {
						let routers = [];
						commit('SET_ROUTERS', routers)
						commit('SET_AUTH', JSON.stringify(e.data))
						resolve()
					}else{
						Message.error({ background: true,duration:3, content: e.msg });
						resolve()
					}
				}).catch(function (e) {
					Message.error({ background: true,duration:3, content: '请求发送失败' });
					resolve()
				});
			}
		})
	}
}

export default new Vuex.Store({
	state,mutations,getters,actions
})


// WEBPACK FOOTER //
// ./src/store/store.js